import { Api } from '../api';
import { ICreateOrgFornecedora, IDetalheOrgFornecedora, IResponseDetalheOrgFornecedora, IResponseOrgFornecedora, IResponseOrgFornecedoralog, IUpdateStatus } from 'shared/types';

//teste nova endpoint
const getAll = async (idorg:number,filter = ''): Promise<IResponseOrgFornecedora | Error> => {
  try {
    const { data, status } = await Api.get(`/org/${idorg}/OrgFornecedora/${filter !== '' ? '?' : ''}${filter}`);

    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllLogs = async (idOrg:number, filter = ''): Promise<IResponseOrgFornecedoralog | Error> => {
  try {
    const { data, status } = await Api.get(`/${idOrg}/OrgFornecedoraLog/${filter !== '' ? '?' : ''}${filter}`);

    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return { rows: [], count: 0 };
    }

    

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};


const getByIds = async (org: number, forn: number): Promise<IDetalheOrgFornecedora | Error> => {
  try {
    const { data, status } = await Api.get(`Orgs/${org}/FornecedoraOrg/${forn}`);
    if (data) {
      return data;
    }
    
    // if (status === 204) {
    //   return {  };
    // }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const create = async (org: number, dados: ICreateOrgFornecedora): Promise<string | Error> => {
  try {

    if (String(dados.Senha) !== String(dados.ConfirmarSenha)){
      return new Error ('Senhas erradas');
    }
    
    const { data, status } = await Api.post(`/Org/${org}/FornecedoraOrg`, dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem}`);
      }
      if (status > 299) {
        if('errors' in data){
          const chaves = Object.keys(data.errors); // Acessar a primeira chave const primeiraPropriedade = chaves[0];
          return new Error(data.errors[chaves[0]][0]);
        }else{
          return new Error(`${data.retorno} `);    
        }
      }
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const update = async (org: number, dados: ICreateOrgFornecedora): Promise<void | Error> => {
  try {

    if ((String(dados.Senha) !== String(dados.ConfirmarSenha))){
      return new Error ('As senhas não combinam');
    }
    if(String(dados.Senha).trim() == '' && String(dados.ConfirmarSenha).trim() == ''){
      return new Error ('Preencha o campo de senha');
    }

    const { data, status } = await Api.put(`/Org/${org}/FornecedoraOrg`, dados);
    const { erro } = data;

    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data.retorno);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const updateStatus = async (org: number, dados: IUpdateStatus): Promise<void | Error> => {
  try {

    const { data, status } = await Api.put(`/Org/${org}/FornecedoraOrg/Status`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};


const deleteD = async (org: string): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${org}/FornecedoraOrg/${org}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};


export const OrgFornecedoraService = {
  getAll,
  getAllLogs,
  create,
  update,
  deleteD,
  getByIds,
  updateStatus,
};
